import React from 'react';
import PropTypes from 'prop-types';
import CountdownComponent from 'components/countdown';

export default function Countdown({ now, deadline, text, facet }) {
    return (
        <div className="cms-countdown">
            <div className="cms-countdown--countdown-container">
                <CountdownComponent endDate={deadline} startDate={now} callback={() => {}} facet={facet} />
            </div>
            <div className="cms-countdown--text" dangerouslySetInnerHTML={{ __html: text }} />
        </div>
    );
}

Countdown.propTypes = {
    now: PropTypes.string.isRequired,
    deadline: PropTypes.string.isRequired,
    text: PropTypes.string,
    facet: PropTypes.any,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/countdown/index.js